/**
 * Chuỗi của nhóm màn `khuon` (Truy vấn mẫu) thuộc module `tro-ly-ai` — tạm tách tệp khi dựng song song, sẽ gộp vào
 * `vi.ts`. Khoá cấp một mang tiền tố `troLyAiKhuon`; sâu tối đa hai cấp dưới nó.
 *
 * Chuỗi có `{ky}`, `{so_dong}`… (một cặp ngoặc) là cú pháp mẫu tóm tắt của MÁY CHỦ, không phải tham số nội suy.
 */
export const viKhuon = {
  troLyAiKhuon: {
    nhom: 'Nhóm nghiệp vụ',
    themNhom: 'Thêm nhóm',
    xoaNhom: 'Xoá nhóm',
    doiTenNhom: 'Đổi tên nhóm',
    themKhuon: 'Thêm truy vấn mẫu vào nhóm này',
    thaoTacNhom: 'Thao tác với nhóm {{ten}}',
    xoaNhomXacNhan: 'Xoá nhóm «{{ten}}»?',
    xoaNhomXacNhanMoTa: 'Nhóm bị xoá khỏi danh sách nghiệp vụ. Không hoàn tác được.',
    chuaCoNhom: 'Chưa có nhóm nào',
    nhomRong: 'chưa có truy vấn mẫu',
    tenNhomPlaceholder: 'Ví dụ: Nhóm nước, Nhóm điện',
    tenNhom: 'Tên nhóm',
    chonMotKhuon: 'Chọn một truy vấn mẫu bên trái, hoặc thêm truy vấn mẫu mới vào một nhóm',
    batDauBangNhom: 'Bắt đầu bằng một nhóm nghiệp vụ — ví dụ “Nhóm nước”',
    ten: 'Tên truy vấn mẫu',
    tenPlaceholder: 'Ví dụ: Doanh thu theo tháng và khu vực',
    thuocNhom: 'Thuộc nhóm',
    cachGoi: 'Cách gọi khác',
    cachGoiPlaceholder: 'doanh thu, doanh số, tiền về',
    cachGoiViSao:
      'Cách khác mà người dùng hay gọi cùng một nghiệp vụ. Trợ lý dùng để nhận ra truy vấn mẫu nào phù hợp.',
    cauHoiMau: 'Câu hỏi tiêu biểu',
    cauHoiMauPlaceholder: 'Doanh thu tháng 7 là bao nhiêu?\nDoanh thu từng khu vực quý này?',
    cauHoiMauViSao:
      'Mỗi dòng một câu. Vừa giúp trợ lý nhận ra truy vấn mẫu, vừa là bộ câu kiểm thử khi bạn sửa câu lệnh.',
    cauLenh: 'Câu lệnh SQL ({{pn}})',
    cauLenhPlaceholder:
      "SELECT thang, khu_vuc, SUM(thanh_tien) AS doanh_thu\nFROM hoa_don\nWHERE trang_thai <> '9'\nGROUP BY thang, khu_vuc",
    luu: 'Lưu',
    xoa: 'Xoá truy vấn mẫu',
    chayThu: 'Chạy thử',
    luuTruocKhiChay: 'Lưu câu lệnh mới trước khi chạy thử',
    daLuu: 'Đã lưu truy vấn mẫu.',
    daLuuChuaChayThu: 'Đã lưu. Bấm Chạy thử để truy vấn mẫu này được dùng khi trả lời.',
    daLuuNhom: 'Đã lưu nhóm.',
    daXoaNhom: 'Đã xoá nhóm.',
    daXoa: 'Đã xoá truy vấn mẫu.',
    daDoiCheDo: 'Đã đổi cách khai báo.',
    sqlDoiThiPhaiChayLai:
      'Câu lệnh đã thay đổi. Lưu xong cần chạy thử lại — câu lệnh mới chưa được kiểm chứng nên tạm thời chưa được dùng khi trả lời.',
    chayThuXong: 'Chạy được, ra {{n}} dòng.',
    chayThuKhongDong: 'Câu lệnh chạy được nhưng không ra dòng nào.',
    ketQuaTomTat: '{{n}} dòng · {{ms}} ms',
    khongDongViSao:
      'Câu lệnh đúng nhưng kho chưa có dữ liệu khớp. Truy vấn mẫu vẫn dùng được — chỉ nên xem lại điều kiện lọc nếu bạn mong có số.',
    daSanSang: 'Đã dùng được',
    chuaSanSang: 'Chưa dùng được',
    viSaoChuaSanSang: 'Truy vấn mẫu chưa chạy thử lần nào, nên trợ lý chưa dùng nó để trả lời. Bấm Chạy thử.',
    phamViTieuDe: 'Phạm vi trợ lý được đọc',
    phamViViSao:
      'Đúng những bảng và cột này, không hơn. Câu hỏi cần dữ liệu ngoài phạm vi sẽ không trả lời được.',
    phamViChuaLuu: 'Lưu truy vấn mẫu để xem phạm vi câu lệnh này mở ra.',
    phamViRong: 'Câu lệnh chưa dùng bảng nào đã khai báo.',
    moiCot: 'mọi cột (câu lệnh dùng SELECT *)',
    congDonLa: 'Cộng dồn được: {{cot}}',
    dangBatKhuon: 'Đang khai báo bằng truy vấn mẫu',
    dangBatCauHoi: 'Đang khai báo bằng câu hỏi',
    tomTatSanSang: '{{san}}/{{tong}} truy vấn mẫu đã chạy thử',
    sangKhuon: 'Chuyển sang khai báo bằng truy vấn mẫu',
    veCauHoi: 'Quay về khai báo bằng câu hỏi',
    doiChieuTieuDe: 'Đổi cách khai báo?',
    gatSangKhuonNghia:
      'Sau khi chuyển, trợ lý chỉ trả lời trong phạm vi các truy vấn mẫu đã khai báo, và quyền đọc tính theo tab “Theo truy vấn mẫu” ở màn Phân quyền dữ liệu. Ma trận quyền theo bảng/cột tạm thời không còn hiệu lực.',
    gatVeCauHoiNghia:
      'Sau khi chuyển, trợ lý trả lời trên toàn bộ bảng đã khai báo, và quyền đọc tính theo ma trận bảng/cột. Các truy vấn mẫu vẫn được giữ và vẫn dùng để điền sẵn ở màn Khai báo nghiệp vụ.',
    soKhuon: 'Tổng số truy vấn mẫu',
    soKhuonSanSang: 'Đã chạy thử',
    vaiSeHetHoiDuoc: 'Những vai trò này sẽ không hỏi được gì',
    vaiSeHetHoiDuocViSao:
      'Các vai trò này chưa được cấp truy vấn mẫu nào. Hãy cấp ở màn Phân quyền dữ liệu, tab “Theo truy vấn mẫu”, trước khi chuyển.',
    khuonChuaChayThu: 'Truy vấn mẫu chưa chạy thử — sẽ không được dùng',
    khuonBiHa: 'Truy vấn mẫu không còn khớp với lược đồ hiện tại',
    banKhaiCu: 'Bản khai báo chưa có cột mà câu lệnh dùng — bảng: {{bang}}',
    banKhaiCuViSao:
      'Nền tảng đối chiếu câu lệnh với bản khai báo, không phải với lược đồ thực tế. Câu lệnh có thể vẫn chạy đúng trên cơ sở dữ liệu; đây thường là dấu hiệu nguồn đã thêm cột sau lần khai báo gần nhất. Bấm nút dưới để khai báo lại đúng bảng ấy — khai báo nghiệp vụ đã có (nhãn cột, nghĩa mã, ý nghĩa mỗi dòng) được giữ nguyên.',
    capNhatBanKhai: 'Cập nhật bản khai báo từ nguồn rồi lưu lại',
    daCapNhatBanKhai: 'Đã cập nhật bản khai báo. Đang lưu lại truy vấn mẫu...',
    khongThayBangONguon: 'Không tìm thấy bảng {{bang}} ở nguồn. Có thể bảng đã bị đổi tên hoặc xoá.',
    loaiKhuon: 'Loại truy vấn mẫu',
    loaiCauLenh: 'Câu lệnh SQL mẫu',
    loaiThuTuc: 'Thủ tục / hàm có sẵn trong CSDL',
    loaiApi: 'API nghiệp vụ',
    duongDanApi: 'Gọi API nào',
    duongDanApiViSao:
      'Đường dẫn nối sau địa chỉ gốc của nguồn. Chỗ nào thay theo câu hỏi thì viết {tên_tham_số} và khai báo tham số đó ở vị trí «đường dẫn». Địa chỉ gốc và khoá lấy từ nguồn — đổi ở Kết nối nguồn.',
    duongDanApiNgan:
      'API phải trả về rows (danh sách dòng) và tongHop (dòng tổng, tuỳ chọn). Lọc, cộng và phân quyền dữ liệu là việc của API.',
    phuongThuc: 'Phương thức',
    diaChiGoc: 'Địa chỉ gốc',
    cotViTri: 'Đi vào',
    viTriQuery: 'Truy vấn (?a=)',
    viTriPath: 'Đường dẫn',
    viTriBody: 'Thân (POST)',
    loaiCauLenhViSao:
      'Trợ lý vẫn tự viết câu lệnh SQL — truy vấn mẫu chỉ giới hạn phạm vi được viết. Linh hoạt hơn: câu hỏi khác đi đôi chút vẫn trả lời được.',
    loaiThuTucViSao:
      'Trợ lý không viết câu lệnh SQL — chỉ chọn nghiệp vụ rồi điền tham số. Chính xác tuyệt đối, nhưng chỉ trả lời được đúng những câu mà thủ tục đã tính sẵn. Dùng được cả hàm PostgreSQL trả TABLE lẫn stored procedure SQL Server. Cần nguồn ở chế độ đọc trực tiếp (bản sao chỉ chứa dữ liệu đã đồng bộ về, không có thủ tục). Không đổi được loại sau khi đã lưu.',
    tenThuTuc: 'Tên thủ tục / hàm (kèm lược đồ nếu có)',
    thamSo: 'Tham số',
    thamSoViSao:
      'Liệt kê đúng thứ tự tham số của thủ tục. Cách điền: «Trợ lý điền» — trợ lý suy từ câu hỏi, nên mô tả là thứ duy nhất cho nó biết tháng là 1-12; thiếu mô tả thì tham số dễ điền sai ra một con số hợp lý của kỳ khác. «Giá trị cố định» — hằng số của truy vấn mẫu, luôn gửi, trợ lý không đổi được; dùng cho tham số tự-khai-phạm-vi như p_vai mà hàm so bằng kiem_vai. «Vai trò người hỏi» — nền tảng tự điền vai trò của người đang hỏi. Tham số không điền: tham số có mặc định thì bỏ để mặc định có hiệu lực; SQL Server truyền NULL cho tham số không có mặc định.',
    cotHienThi: 'Cột hiển thị',
    cotHienThiViSao:
      'Đặt nhãn và định dạng (tiền, số, ngày, phần trăm) cho từng cột kết quả. Cột không khai báo thì hiện nguyên tên cột trả về.',
    tongHop: 'Tổng hợp — object JSON {tên_cột: kiểu} (tập kết quả thứ 2)',
    tongHopViSao:
      'Chỉ dùng khi thủ tục trả hai tập kết quả (thường là SQL Server: chi tiết rồi một dòng tổng). Hàm Postgres trả TABLE chỉ có một tập — để trống {}.',
    tomTat: 'Mẫu tóm tắt',
    tomTatPlaceholder: 'Doanh thu {ky}: tổng {tong_doanh_thu}, {so_khach_hang} khách hàng.',
    tomTatViSao:
      'Ô dùng được: {tên_cột_tổng_hợp} · {ky} (ghép từ tham số nam/thang) · {so_dong} · {param:tên} · {top:cột_tên:cột_giá_trị:N}. Ô không hiểu được sẽ bỏ trống, không in ra {…}.',
    tieuDe: 'Tiêu đề hiển thị (tuỳ chọn)',
    tieuDePlaceholder: 'Doanh thu theo khách hàng {ky}',
    thamSoChayThu: 'Tham số cho lượt chạy thử',
    thamSoChayThuViSao:
      'Để trống là chạy trên toàn bộ dữ liệu — thủ tục viết cho kiểu dùng này đặt mặc định NULL và tự bỏ qua điều kiện.',
    soTap: '{{n}} tập kết quả',
    dongTongHop: 'Dòng tổng hợp',
    nenTangTuDien: 'Nền tảng tự điền',
    vaiNguoiHoi: 'vai trò của người hỏi',
    khuonMoi: 'Truy vấn mẫu mới',
    chuaLuu: 'Chưa lưu',
    coThayDoi: 'Có thay đổi chưa lưu',
    phimTatLuu: 'Ctrl+S để lưu',
    xoaXacNhan: 'Xoá truy vấn mẫu này?',
    xoaXacNhanMoTa: 'Trợ lý sẽ không dùng truy vấn mẫu này để trả lời nữa. Không hoàn tác được.',
    tabNhanDien: '1. Nhận diện',
    tabLayDuLieu: '2. Lấy dữ liệu',
    tabTrinhBay: '3. Trình bày',
    tabChayThu: '4. Chạy thử & phạm vi',
    tabCoLoi: 'Còn thông tin bắt buộc chưa điền',
    soCauHoiMau: '{{n}} câu',
    loaiCauLenhNgan: 'Trợ lý tự viết SQL trong phạm vi câu lệnh mẫu — linh hoạt với câu hỏi khác đi đôi chút.',
    loaiThuTucNgan:
      'Trợ lý chỉ chọn thủ tục và điền tham số — chính xác tuyệt đối, nhưng chỉ trả lời được câu thủ tục đã tính sẵn.',
    loaiKhongDoiDuoc: 'Không đổi được loại sau khi đã lưu.',
    suaJson: 'Sửa dạng JSON',
    xemBang: 'Xem dạng bảng',
    jsonLoiQuayBang: 'JSON đang lỗi — sửa xong mới quay lại dạng bảng được.',
    thamSoJsonGoiY:
      'Mảng [{ten, kieu, moTa, batBuoc, nguon, giaTri}] — kieu: int | string | date | decimal | bool; nguon: "" hoặc "dang_nhap".',
    cotJsonGoiY: 'Mảng [{field, nhan, kieu}] — kieu: text | tien | ngay | so | phan_tram.',
    themThamSo: 'Thêm tham số',
    chuaCoThamSo: 'Chưa có tham số — thủ tục sẽ được gọi không kèm tham số nào.',
    cotTen: 'Tên',
    cotKieu: 'Kiểu',
    cotCachDien: 'Cách điền',
    cotMoTaGiaTri: 'Mô tả / giá trị',
    cotBatBuoc: 'Bắt buộc',
    dienTroLi: 'Trợ lý điền',
    dienCoDinh: 'Giá trị cố định',
    dienDangNhap: 'Vai trò người hỏi',
    moTaThamSoPlaceholder: 'vd: tháng 1-12',
    thieuMoTa: 'Thiếu mô tả — trợ lý dễ điền sai giá trị.',
    boDong: 'Bỏ dòng này',
    themCot: 'Thêm cột',
    layCotTuKetQua: 'Lấy {{n}} cột từ lần chạy thử',
    chuaCoCot: 'Chưa khai báo cột nào — kết quả hiện nguyên tên cột trả về.',
    cotField: 'Cột trả về',
    cotNhan: 'Nhãn hiển thị',
    cotNhanPlaceholder: 'vd: Doanh thu (VND)',
    kieuText: 'Chữ',
    kieuSo: 'Số',
    kieuTien: 'Tiền',
    kieuPhanTram: 'Phần trăm',
    kieuNgay: 'Ngày',
    chen: 'Chèn:',
    chenO: 'Chèn {{o}} vào mẫu tóm tắt',
    nangCao: 'Nâng cao',
    chayThuCanLuu: 'Lưu truy vấn mẫu trước rồi mới chạy thử được.',
    chuaChayThuPhien: 'Chưa chạy thử trong phiên này. Kết quả sẽ hiện ở đây.',
    bangThamSo: 'Tham số của truy vấn mẫu',
    bangCot: 'Cột hiển thị của truy vấn mẫu',
    bangKetQua: 'Mười dòng đầu của lượt chạy thử',
    caiNay: 'Giải thích',
  },
  troLyAiKhuonView: {
    tieuDe: 'Truy vấn mẫu',
    phuDe:
      'Nghiệp vụ đã tính sẵn — câu lệnh mẫu, thủ tục trong CSDL hay API của khách. Trợ lý chọn truy vấn mẫu và điền tham số, không tự viết phép tính.',
    theoKhuon: 'Trả lời theo truy vấn mẫu',
    theoBanKhai: 'Trả lời theo khai báo nghiệp vụ',
    moiCheDo: 'Mọi cách trả lời',
    chuaCoKhuon: 'Chưa có truy vấn mẫu nào',
    khongDemDuoc: 'Không đọc được danh sách truy vấn mẫu',
    demKhuon: '{{tong}} truy vấn mẫu · {{sanSang}} đã dùng được',
    tatCaNguon: 'Tất cả nguồn',
    khongCoNguon: 'Không tìm thấy nguồn',
    khongCoNguonMoTa: 'Nguồn «{{ma}}» không tồn tại hoặc tài khoản này không được thấy nó.',
    nguonApiGhi:
      'Nguồn API luôn trả lời theo truy vấn mẫu. Mỗi truy vấn mẫu là một API nghiệp vụ; chạy thử thành công rồi cấp quyền ở Phân quyền dữ liệu là trợ lý dùng được.',
  },
} as const;
